
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-is-plaid-involved",
      function () {
        return require("private-next-pages/why-is-plaid-involved.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-is-plaid-involved"])
      });
    }
  